import _ButtonBase from "@material-ui/core/esm/ButtonBase";
const _excluded = ["header", "message", "children", "messageIsFromUser", "handleDeleteMessage", "handleEditMessage"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { useStyles } from "./MessageContainerStyles";
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import ReplySharpIcon from '@material-ui/icons/ReplySharp';
import { Header } from "./Header";
import { Info } from "./Info";
import { Menu, useMenu } from "./Menu";
import { RepliedMessagePreview } from "./RepliedMessagePreview";
import { useMessenger } from "../../Messenger";
import { useChat } from "../../Chat";
import { Caption } from "./Caption/Caption";

var _ref2 = /*#__PURE__*/_jsx(ReplySharpIcon, {});

const MessageContainer = _ref => {
  let header = _ref.header,
      message = _ref.message,
      children = _ref.children,
      messageIsFromUser = _ref.messageIsFromUser,
      handleDeleteMessage = _ref.handleDeleteMessage,
      handleEditMessage = _ref.handleEditMessage,
      styleProps = _objectWithoutProperties(_ref, _excluded);

  const _useChat = useChat(),
        setReplyingTo = _useChat.setReplyingTo,
        messages = _useChat.messages;

  const _useMessenger = useMessenger(),
        config = _useMessenger.config.chat.messages.options;

  const classes = useStyles(styleProps);
  const menu = useMenu(message.id);

  const sideContainer = _jsx("div", {
    className: classes.sideContainer
  }, void 0, config.response && _jsx(_ButtonBase, {
    disableRipple: true,
    onClick: () => setReplyingTo(message)
  }, void 0, _ref2));

  const repliedMessage = messages.find(repliedMessage => repliedMessage.id === message.replyTo);
  return React.createElement(React.Fragment, null, menu.position && React.createElement(Menu, _extends({
    message: message
  }, menu, {
    handleDeleteMessage: handleDeleteMessage,
    handleEditMessage: handleEditMessage
  })), _jsx("div", {
    id: "".concat(message.id, "Row"),
    className: classes.row
  }, void 0, styleProps.anchor === 'right' && sideContainer, _jsx("div", {
    className: classes.container
  }, void 0, header && _jsx(Header, {
    styleProps: styleProps,
    text: message.from
  }), repliedMessage && _jsx(RepliedMessagePreview, {
    header: !!header,
    type: message.type,
    repliedMessage: repliedMessage,
    styleProps: styleProps
  }), children, message.caption && _jsx(Caption, {
    message: message,
    styleProps: styleProps
  }), _jsx(Info, {
    message: message,
    styleProps: styleProps,
    messageIsFromUser: messageIsFromUser
  })), styleProps.anchor === 'left' && sideContainer));
};

export { MessageContainer };